var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.58086 4.37243C1.58086 2.91059 2.17479 1.8386 3.12231 1.11992C4.08442 0.390186 5.44663 0 7 0C8.55336 0 9.91557 0.390186 10.8777 1.11993C11.8252 1.8386 12.4191 2.91059 12.4191 4.37243C12.4191 6.34303 13.1413 8.51565 13.8615 10.2009C14.3405 11.3219 13.5128 12.6143 12.3677 12.6143H1.63228C0.487155 12.6143 -0.340466 11.3219 0.138526 10.2009C0.858567 8.51568 1.58086 6.34304 1.58086 4.37243Z",
    fill: "#666666"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.52605 14.0459V13.5429H9.47395V14.0459C9.47395 14.7064 9.20967 15.1738 8.79514 15.4882C8.36601 15.8137 7.7401 16 7 16C6.2599 16 5.63398 15.8137 5.20486 15.4882C4.79033 15.1738 4.52605 14.7064 4.52605 14.0459Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/Bell.376eb537a07eb3c4d27e518262953af3.svg";
export { ForwardRef as ReactComponent };